import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Media,
  UncontrolledTooltip
} from 'reactstrap';
import { ClipboardCheck, Clipboard as ClipboardIcon } from 'react-bootstrap-icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Trans, useTranslation } from 'react-i18next';
import SimpleHeader from '../../components/Headers/SimpleHeader';
import { getLoginUrl } from '../../utils/helpers';

const Icon = () => {
  const { t } = useTranslation();

  const [loginUrl, setLoginUrl] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    (async () => {
      const url = getLoginUrl('visits');
      setLoginUrl(url);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SimpleHeader name={t('icon.title', 'Ikon')} />

      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">{t('icon.sub-title', 'Hämta genväg')}</h3>
                </CardHeader>
                <CardBody>
                  <h3>{t('icon.mandatory-title')}</h3>
                  <p>
                    <Trans i18nKey="icon.mandatory-text">
                      Drag följande länk <a href={{ loginUrl }}>{{ loginUrl }}</a> direkt till
                      skrivbordet på er dator. Det skapas då automatiskt en länk till
                      besöksregistreringen. Ni drar länken genom att vänsterklicka på den och medan
                      ni fortsätter att hålla musknappen nedtryckt drar ni ut länken till
                      skrivbordet.
                    </Trans>
                  </p>
                  <p>{t('icon.mandatory-text-extra')}</p>

                  <CopyToClipboard text={loginUrl} onCopy={() => setCopied(true)}>
                    <Button className="btn-icon-clipboard" id="tooltip982655500" type="button">
                      <div>
                        {copied ? <ClipboardCheck /> : <ClipboardIcon />}
                        <span>{loginUrl}</span>
                      </div>
                    </Button>
                  </CopyToClipboard>
                  <UncontrolledTooltip delay={0} trigger="hover focus" target="tooltip982655500">
                    {copied ? t('default.copied') : t('icon.copy', 'Kopiera till urklipp')}
                  </UncontrolledTooltip>

                  <h3 className="mt-4">{t('icon.optional-title', 'Valfritt moment')}</h3>
                  <p>{t('icon.optional-text')}</p>
                  <Media
                    src="https://www.golfamore.com/admin-gc/assets/img/icon-golfhaftet.ico"
                    style={{ maxWidth: '50px', marginBottom: '20px' }}
                  />
                  <p>{t('icon.optional-text-extra')}</p>
                  {/* <Media
              src="https://www.golfamore.com/admin-gc/assets/img/golfhaftet-bg.png"
              style={{ maxWidth: '300px' }}
            /> */}
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Icon;
